import { hsaPdpWidgetPlacementSchema } from "@redotech/redo-conversion-settings-common/hsa-settings";
import * as z from "zod";

export const getHsaSettings = {
  name: "getHsaSettings" as const,
  input: z.null(),
  output: z.object({
    /** The master HSA/FSA product switch. Client code reads it here rather than
     * from `team.settings`, which stops carrying it after the SET-415 cutover. */
    enabled: z.boolean(),
    pdpWidgetPlacement: hsaPdpWidgetPlacementSchema.optional(),
    /** Customer-facing checkout display name, applied display-only by the
     * payment-customization Function. */
    paymentMethodName: z.string().optional(),
  }),
};
